var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toolbar-container" }, [
    _c(
      "div",
      { staticClass: "toolbar" },
      [
        _c(
          "b-row",
          { staticStyle: { gap: "20px" }, attrs: { "no-gutters": "" } },
          [
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                {
                  class: _vm.zoomClass,
                  attrs: { title: "Current Zoom Level" },
                },
                [
                  _c("div", { staticClass: "white-outline highlight" }, [
                    _c("div", [_vm._v(" " + _vm._s(_vm.zoomFloor) + " ")]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sm highlight toolbar-icon",
                attrs: { title: "Mileage Slider" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggleSlider")
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "sliders-h"], size: "lg" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sm highlight toolbar-icon",
                attrs: { title: "Upload CSV Here!" },
                on: {
                  click: function ($event) {
                    return _vm.$bvModal.show("POIUploadModal")
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "upload"], size: "lg" } })],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }